"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var splitio_1 = require("@splitsoftware/splitio");
var path_1 = __importDefault(require("path"));
var constants_1 = require("./constants");
var isClientSide_1 = __importDefault(require("./isClientSide"));
var factory;
var client;
var initiateSplitClient = function () { return __awaiter(void 0, void 0, void 0, function () {
    var authorizationKey, debug, localhostMode, features, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if ((0, isClientSide_1.default)()) {
                    throw new Error("Do not initiate Split client-side. This function is not designed to handle client-side initiation.");
                }
                authorizationKey = process.env.SPLIT_SERVER_KEY || "localhost";
                debug = process.env.SPLIT_DEBUG;
                localhostMode = authorizationKey === "localhost";
                features = localhostMode
                    ? path_1.default.join(process.cwd(), "split-config.yml")
                    : undefined;
                factory || (factory = (0, splitio_1.SplitFactory)({
                    core: {
                        authorizationKey: authorizationKey,
                    },
                    debug: debug === "true",
                    features: features,
                }));
                client || (client = factory.client());
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, client.ready()];
            case 2:
                _a.sent();
                return [2 /*return*/, client];
            case 3:
                e_1 = _a.sent();
                throw new Error((typeof e_1 === "object" && e_1.message) || constants_1.GENERIC_CLIENT_ERROR);
            case 4: return [2 /*return*/];
        }
    });
}); };
process.on("exit", function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (client === null || client === void 0 ? void 0 : client.destroy())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
exports.default = initiateSplitClient;
